import React, { useEffect } from "react";
import fish_fry from '../../images/events/fish-fry.png';

function FishFryPage() {

  useEffect(() => {
    window.location.href = "https://kofc1056.square.site/";
  }, []);

  return (
    <>
      <div className="d-flex justify-content-center">
        <a href="https://kofc1056.square.site/">
          <h5 className="d-flex justify-content-center">Navigating to Fish Fry Page</h5>
        </a>
      </div>
    </>
  );
}

export default FishFryPage;